'use client';

import dynamic from 'next/dynamic';

const WhimsicalAnimationsDemo = dynamic(() => import('./index'));

export default WhimsicalAnimationsDemo;
